import { render } from "./CustomerAccount.vue?vue&type=template&id=717f0d67&scoped=true"
import script from "./CustomerAccount.vue?vue&type=script&lang=js"
export * from "./CustomerAccount.vue?vue&type=script&lang=js"

import "./CustomerAccount.vue?vue&type=style&index=0&id=717f0d67&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717f0d67"]])

export default __exports__